export default __webpack_public_path__ + "static/media/extension-desktop-accounts.c099d274.png";